import { useEffect } from "react";

import useDecodedParams from "Hooks/useDecodedParams";
import { getAutoscalingConfigurationThunk } from "Reducers/environment/service/service.slice";
import { useAppDispatch } from "Store/hooks";

const useLoadAutoScale = () => {
  const dispatch = useAppDispatch();
  const { projectId, environmentId } = useDecodedParams();
  useEffect(() => {
    dispatch(getAutoscalingConfigurationThunk({ projectId, environmentId }));
  }, [dispatch, projectId, environmentId]);
};

export default useLoadAutoScale;
